<template>
    <ul class="nav nav-tab mb-5">
        <li class="nav-item ml-0 pl-0" :class="{active: tab=='history'}">
            <router-link :to="'/fulfillment'" class="nav-link">
                Invoices
            </router-link>
        </li>
        <li class="nav-item" :class="{active: tab=='import'}">
            <router-link :to="'/fulfillment/import'" class="nav-link">
                Import Orders
            </router-link>
        </li>
        <li class="nav-item" :class="{active: tab=='template'}">
            <router-link class="nav-link" :to="'/fulfillment/template'">
                Template Help
            </router-link>
        </li>

    </ul>
</template>

<script>
    export default {
        name: "NavFulfillment",
        props: [
            'tab'
        ]
    }
</script>

<style scoped lang="scss">

</style>